import {request} from "../../Base/HTTP";
import HttpMethod from "../../Constants/Base/HttpMethod";

export async function getPipelineAccess(pipelineId) {
    return await request(`/api/pipeline-access`, {pipelineId});
}

export async function updatePipelineAccess(data) {
    return await request(`/api/pipeline-access/${data.pipelineId}/${data.userId}`, data, HttpMethod.PUT);
}